export default {
  "content": "<path d=\"M0 0h48v48H0z\" fill=\"none\"/><path d=\"M5 37h38v4H5z\" fill=\"#D7D8DE\"/><path d=\"M43 6H5a1 1 0 00-1 1v34a1 1 0 001 1h38a1 1 0 001-1V7a1 1 0 00-1-1zm-1 2v28H6V8zM6 40v-2h36v2z\" fill=\"#3F4450\"/><path d=\"M11.707 21.707l4-4a.999.999 0 000-1.414l-4-4-1.414 1.414L13.586 17l-3.293 3.293zM16 20h8v2h-8z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};